
import React, { useEffect, useState } from 'react';
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// import locales
import enTranslation from './en';
import spTranslation from './sp';
// import frTranslation from './fr';

// the translations
// (tip move them in a JSON file and import them)
var lang = localStorage.getItem("lang")
console.log('lang',lang)
export const Languagechange = (Language) =>
{
    i18n.changeLanguage(Language);
    localStorage.setItem("lang",Language)
}

const resources = {
    en: {
        'translation': enTranslation
    },
    sp: {
        'translation': spTranslation
    },
    // fr: {
    //     'translation': frTranslation
    // },
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: lang ? lang : "en",

        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;